/**
 * Messages, Alerts & Feedback — semantic tonal tokens.
 * Spec: DesignTest/DESIGN.md (Component Suite 03)
 */

/** Muted green — success (not slate-teal). */
export const ENTERPRISE_SUCCESS_TONAL = {
  surface: "#ECFDF3",
  onSurface: "#14532D",
  icon: "#15803D",
  iconDisc: "#15803D",
  accent: "#047857",
  muted: "rgba(20, 83, 45, 0.45)",
};

/** Muted red — error (not pink/coral wash). */
export const ENTERPRISE_ERROR_TONAL = {
  surface: "#FEF2F2",
  onSurface: "#7F1D1D",
  icon: "#B91C1C",
  iconDisc: "#B91C1C",
  accent: "#991B1B",
  muted: "rgba(127, 29, 29, 0.45)",
};

export const ENTERPRISE_MESSAGE_VARIANTS = {
  success: {
    surface: ENTERPRISE_SUCCESS_TONAL.surface,
    onSurface: ENTERPRISE_SUCCESS_TONAL.onSurface,
    onSurfaceMuted: "#166534",
    iconBg: ENTERPRISE_SUCCESS_TONAL.iconDisc,
    iconFg: "#FFFFFF",
    actionBg: ENTERPRISE_SUCCESS_TONAL.iconDisc,
    actionFg: "#FFFFFF",
    actionHover: "#14532D",
  },
  warning: {
    surface: "#EEEEEE",
    onSurface: "#1C1B1F",
    onSurfaceMuted: "#494551",
    iconBg: "#1C1B1F",
    iconFg: "#FFFFFF",
    actionBg: "#FFFFFF",
    actionFg: "#1C1B1F",
    actionBorder: "#CAC4D0",
    actionHover: "rgba(28, 27, 31, 0.06)",
  },
  error: {
    surface: ENTERPRISE_ERROR_TONAL.surface,
    onSurface: ENTERPRISE_ERROR_TONAL.onSurface,
    onSurfaceMuted: "#991B1B",
    iconBg: ENTERPRISE_ERROR_TONAL.iconDisc,
    iconFg: "#FFFFFF",
    actionBg: ENTERPRISE_ERROR_TONAL.iconDisc,
    actionFg: "#FFFFFF",
    actionHover: "#7F1D1D",
  },
  info: {
    surface: "#E8E8E8",
    onSurface: "#1C1B1F",
    onSurfaceMuted: "#494551",
    iconBg: "#494551",
    iconFg: "#FFFFFF",
    actionBg: "#1C1B1F",
    actionFg: "#FFFFFF",
    actionHover: "#000000",
  },
};

export const ENTERPRISE_TOAST_INFO = {
  surface: "#1C1B1F",
  onSurface: "#F5F5F5",
  accent: "#B4A7FF",
  muted: "#CAC4D0",
};

/** Amber warning — compact toast. */
export const ENTERPRISE_WARNING_TONAL = {
  surface: "#FFFBEB",
  onSurface: "#92400E",
  icon: "#D97706",
  iconDisc: "#D97706",
  accent: "#B45309",
  muted: "rgba(146, 64, 14, 0.45)",
};

/** Compact bottom toast — info stays inverse; success/error use soft green/red containers. */
export const ENTERPRISE_TOAST_COMPACT = {
  infoToast: ENTERPRISE_TOAST_INFO,
  info: ENTERPRISE_TOAST_INFO,
  success: { ...ENTERPRISE_SUCCESS_TONAL },
  error: { ...ENTERPRISE_ERROR_TONAL },
  warning: { ...ENTERPRISE_WARNING_TONAL },
};

export const ENTERPRISE_TOAST_SHELL = {
  px: 2,
  py: 1.25,
  gap: 1.25,
  iconSize: 22,
  closeSize: 18,
  messageFontSize: "0.875rem",
  actionFontSize: "0.8125rem",
  minHeight: 48,
  widthSm: 420,
  maxWidth: "min(100vw - 32px, 480px)",
  widthXs: "calc(100vw - 32px)",
};
